import React from 'react'
import PropTypes from 'prop-types'
import {
  ContainerTradeBlotterAgGridTable,
  GridWidget,
  TypographyWidgetStyle
} from '../../TradeBlotter.style'
import { AgGridReact } from 'ag-grid-react'
import { SIGN } from '../../../../utils/constants'
import Pagination from '../../../../components/Pagination/Pagination'

const WidgetTradeBlotter = ({
  gridRef,
  columnsDefs,
  defaultColDef,
  getRowStyle,
  getRowId,
  onBodyScroll,
  onRowClicked,
  onRowGroupOpened,
  onRowDoubleClicked,
  onGridReady,
  onFirstDataRendered,
  onColumnMoved,
  onSortChange,
  onColumnResized,
  getContextMenuItems,
  isServerSideGroup,
  getServerSideGroupKey,
  autoGroupColumnDef,
  onFilterChanged,
  handelPagination,
  page,
  disabled,
  children,
  style
}) => {
  return (
    <>
      <GridWidget style={style}>
        <TypographyWidgetStyle>Trade Blotter</TypographyWidgetStyle>
      </GridWidget>
      {children}
      <ContainerTradeBlotterAgGridTable>
        <AgGridReact
          reactiveCustomComponents={true}
          rowModelType="serverSide"
          ref={gridRef}
          maintainColumnOrder={true}
          onGridReady={onGridReady}
          columnDefs={columnsDefs}
          defaultColDef={defaultColDef}
          groupHeaderHeight={0}
          suppressRowClickSelection={true}
          getRowStyle={getRowStyle}
          rowMultiSelectWithClick={true}
          suppressServerSideFullWidthLoadingRow={true}
          suppressScrollOnNewData={true}
          suppressGroupRowsSticky={true}
          suppressLoadingOverlay={true}
          keepRowHeight={true}
          onColumnMoved={onColumnMoved}
          onRowGroupOpened={onRowGroupOpened}
          detailRowAutoHeight={true}
          getRowId={getRowId}
          onBodyScroll={onBodyScroll}
          onRowClicked={onRowClicked}
          onRowDoubleClicked={onRowDoubleClicked}
          onSortChanged={onSortChange}
          onColumnResized={onColumnResized}
          onFirstDataRendered={onFirstDataRendered}
          getContextMenuItems={getContextMenuItems}
          groupUseEntireRow={true}
          pagination={true}
          paginationPageSize={100}
          suppressPaginationPanel={true}
          onFilterChanged={onFilterChanged}
          treeData={true}
          paginationMode="server"
          isServerSideGroup={isServerSideGroup}
          getServerSideGroupKey={getServerSideGroupKey}
          autoGroupColumnDef={autoGroupColumnDef}
          rowSelection={'multiple'}
        />

        <Pagination
          handelNextPagination={() => handelPagination(SIGN.NEXT)}
          handelPrevPagination={() => handelPagination(SIGN.PREV)}
          page={page}
          disabledPrev={disabled.prev}
          disabledNext={disabled.next}
        />
      </ContainerTradeBlotterAgGridTable>
    </>
  )
}

export default WidgetTradeBlotter

WidgetTradeBlotter.propTypes = {
  handleRemoveWidget: PropTypes.func,
  gridRef: PropTypes.any,
  columnsDefs: PropTypes.array,
  defaultColDef: PropTypes.object,
  getRowStyle: PropTypes.func,
  getRowId: PropTypes.func,
  onBodyScroll: PropTypes.func,
  onFilterChanged: PropTypes.func,
  onRowClicked: PropTypes.func,
  onRowDoubleClicked: PropTypes.func,
  onRowGroupOpened: PropTypes.func,
  onGridReady: PropTypes.func,
  onColumnMoved: PropTypes.func,
  onColumnResized: PropTypes.func,
  onFirstDataRendered: PropTypes.func,
  onSortChange: PropTypes.func,
  getContextMenuItems: PropTypes.func,
  handelPagination: PropTypes.func,
  page: PropTypes.number,
  isServerSideGroup: PropTypes.func,
  getServerSideGroupKey: PropTypes.func,
  autoGroupColumnDef: PropTypes.object,
  disabled: PropTypes.object,
  children: PropTypes.node,
  style: PropTypes.any
}
